import {useEffect} from 'react';
import {
    useNavigate,
    useParams,
} from 'react-router-dom';
import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {Profile} from '../profile/Profile';
import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useTestingAction} from '../hooks/useTestingAction.ts';
import {useTestingActionsSelection} from '../hooks/useTestingActionsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import config from '../config';

export const EditPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`${config.basePath}/${id}`);
    };

    const {
        record,
        updateRecord,
    } = useTestingAction(id);

    const {handleClearSelection} = useTestingActionsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();

    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!record) {
        return <PlatformLoader message='Loading action...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={record.name ? record.name : record.actionCode}
            pageNavigation={<EditPageNavigation component={record}/>}
            tools={tools}
        >
            {mode === 'view' ? (
                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={record}/>
                    </Grid.Col>
                </Grid>
            ) : (
                <RecordForm
                    record={record}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />
            )}
        </FormPageLayout>
    );
};
